<template>
    <div class="block page19 f-r f-c">
        <PageHeader
          :title="moduleData['3_19_1_1']"
          :sub-title="moduleData['3_19_1_1_en']"
          :page-logo="reportCustomization.pageLogo"
        />
        <PageTips :page-num="pageNum"/>
        <div class="page19-body f-r j-b">
            <div class="page19-body-left">
                <div class="page19-body-header f-r j-b a-c">
                    <div class="page19-body-header-left">{{ PAGE_TEXT[commonLang].retailStores }} {{ totalSize }} {{ PAGE_TEXT[commonLang].unitStore }}</div>
                </div>
                <TableNav width="900px">
                    <template v-slot:title> {{ PAGE_TEXT[commonLang].nearestRetailStores }} </template>
                </TableNav>
                <PTable :col-data="colData" :row-data="rowData" style="min-height: 472px">
                  <Empty :text="PAGE_TEXT[commonLang].noRetailCoverage" v-if="!rowData.length"/>
                </PTable>
                <div v-if="reportCustomization.showWater" class="page16-map-tips">
                  <div class="page-tips2" style="padding-bottom: 27px;margin: 23px 0 0">{{ PAGE_TEXT[commonLang].moreInfo }}</div>
                </div>
                <div class="page19-body-header f-r j-b a-c">
                    <div class="page19-body-header-left">{{ PAGE_TEXT[commonLang].storeDistribution }}</div>
                </div>
                <BarChart style="height: 195px; width: 100%"
                          :bar-width="62"
                          color="#17C49D"
                          :x-data="rowData.map(v => v.name)"
                          :y-data="rowData.map(v => v.value)">
                  <Empty :text="PAGE_TEXT[commonLang].noRetailCoverage" v-if="!rowData.length"/>
                </BarChart>
            </div>
            <div class="page19-body-right">
                <div class="page19-body-right f-c">
                    <div class="page13-map" id="page13Map">
                      <Empty :text="PAGE_TEXT[commonLang].noRetailCoverage" v-if="!rowData.length"/>
                    </div>
                    <div class="page13-map-legend f-r a-c f-w">
                      <div
                        class="page13-map-legend-item f-r a-c"
                        v-for="(item, index) in typeList"
                        :key="index"
                      >
                        <div
                          class="page13-map-legend-point point1"
                          :style="{ background: item.color }"
                        ></div>
                        {{ item.name }}
                      </div>
                    </div>
                    <div v-if="reportCustomization.showDataSource" class="page13-map-tips">
                        {{ PAGE_TEXT[commonLang].dataSource }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import PageHeader from "./components/PageHeader";
import PageTips from "./components/PageTips";
import TableNav from "./components/TableNav";
import PTable from "./components/PTable";
import BarChart from "./components/BarChart3";
import Empty from "./components/Empty";

import AMapLoader from "@amap/amap-jsapi-loader";
import { AMAP_KEY } from "@/constants/common";
import { shallowRef } from "@vue/reactivity";

import { computed, onMounted, ref } from "vue";
import { mapAddCircle, addMapCenter, mapAddPolygonV2 } from "@/utils/pdf";
import { useStore } from "vuex";

import { getMapDelayByMarkerCount } from '@/utils'
import {
  drawMapKeepAlive,
} from '@/api/apiv2'

const props = defineProps({
      pageNum: String,
      cityInfo: {
          type: Object,
          default: () => {
              return {};
          },
      },
      catData: {
          type: Array,
          default: () => {
              return  []
          },
      },
      moduleData: {
          type: Object,
          default: () => {
              return {
              };
          },
      },
      // poi改造后数据
      poiData: {
        type: Object,
        default: () => {},
      },
      reportCustomization: {
        type: Object,
        default: () => {},
      },
      commonLang: {
        type: String,
        default: 'zh'
      }
    });

const PAGE_TEXT = {
  'zh': {
    retailStores: '零售门店 共',
    unitStore: '家',
    nearestRetailStores: '距离调研地最近的零售门店（最多展示各 TOP 5）',
    noRetailCoverage: '当前区域暂无零售门店覆盖',
    moreInfo: '>当前图表中仅展示部分分类，全部零售数据于APP「周边配套」中查看',
    storeDistribution: '区域零售门店分布数量（家）',
    dataSource: '数据来源：位置厂商地图数据',
    type: '类型',
    nearestStore: '距离项目最近零售门店'
  },
  'en': {
    retailStores: 'Retail Stores Total',
    unitStore: 'stores',
    nearestRetailStores: 'Nearest Retail Stores to Research Site (Top 5 Maximum for Each)',
    noRetailCoverage: 'No retail store coverage in current area',
    moreInfo: '',
    storeDistribution: 'Regional Retail Store Distribution Quantity (stores)',
    dataSource: 'Data Source: Location vendor map data',
    type: 'Type',
    nearestStore: 'Nearest Retail Store to Project'
  }
};

      const color = [
        "#0045FF",
        "#FF7800",
        '#FF0000',
        '#17C49D',
        '#00BEFF',
        '#A933E4',
        '#00FF19',
        '#DACE10',
        '#6694CF',
        '#F53A99',
        '#A1C607',
        '#6005B1',
        '#FF5E87',
      ];
      const store = useStore()
        const colData = computed(() => [
            { prop: "name", width: "147px", label: PAGE_TEXT[props.commonLang].type },
            { prop: "names", width: "750px", label: PAGE_TEXT[props.commonLang].nearestStore },
        ]);
        const rowData = computed(() => {
            return props.catData.map((el, index) => {
              return {
                name: el.bhProTypeName,
                names: el.poi.slice(0,5).map(el => el.name).join('、'),
                value: el?.count || 0,
                poi: el.poi || [],
                color: color[index],
              }
            })
        });
        // 旧版
        // const totalSize = computed(() => {
        //   if (!rowData.value.length) return 0
        //   return rowData.value.map(el => el.value).reduce((pre,next) => pre + next)
        // })
        // poi改版
        const totalSize = computed(() => {
          if (!props.poiData || !props.poiData?.nearby?.length) return 0
          const item = props.poiData.nearby.find((n) => n.bhProType === 'P080000')
          return item?.count || 0
        })

        let map = shallowRef(null);
        const addMaker = (amap, map, data) => {
          const markerList = [];
          const newData = data?.poi || []
          newData.forEach((v) => {
            let marker = new amap.Marker({
                position: new amap.LngLat(
                    v.location.split(",")[0],
                    v.location.split(",")[1]
                ),
              content: `<div style="width: 12px;height: 12px; border-radius: 50%;background: ${data.color};"></div>`
            });
            markerList.push(marker);
          });
          map.add(markerList);
        };

        onMounted(() => {
            AMapLoader.load({
                key: AMAP_KEY, // 申请好的Web端开发者Key，首次调用 load 时必填
                version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            }).then((AMap) => {
              map = new AMap.Map("page13Map", {
                WebGLParams: {
                    preserveDrawingBuffer:true
                },
                dragEnable: false,
                zoomEnable: false,
                zoom: store.getters.mapZoom, //初始化地图级别
                center: props.cityInfo.location.split(","), //初始化地图中心点位置
              });

              // 按数量排序 多的点先绘制 在底层 视觉效果好一点
              const sortList = rowData.value.sort((a, b) => b.poi.length - a.poi.length)
              for (let i = 0; i < sortList.length; i++) {
                addMaker(AMap, map, sortList[i]);
              }

              if (props.cityInfo.is_polygon) {
                mapAddPolygonV2(props.cityInfo?.polygon || '', map)
              } else {
                mapAddCircle(props.cityInfo, map);
              }
              addMapCenter(AMap, map, props.cityInfo.location)

              // 等待地图渲染
              const totalCount = rowData.value.reduce((a, b) => a + (b?.poi?.length || 0), 0)
              const delay = getMapDelayByMarkerCount(totalCount)
              drawMapKeepAlive(delay).catch((e) => {})

              map.setFitView()
          })
          .catch((e) => {
              console.log(e);
          });
        });

      const typeList = props.catData.map((item, index) => ({
        name: item.bhProTypeName,
        color: color[index],
      }))
</script>

<style lang="less">
.page19 {
    position: relative;
    background: #ffffff;
    padding: 26px 60px 32px 0;
  .page16-map-tips {
    flex-shrink: 0;
    text-align: right;
    font-size: 20px;
    font-weight: 400;
    color: #9a9a9a;
    line-height: 28px;
  }
    .page19-body {
        flex-grow: 1;
        padding: 67px 20px 0 61px;
        td {
            height: 50px;
            font-size: 18px;
            padding: 0 10px;
        }
        td:nth-child(2) {
            text-align: left;
        }
        .page19-body-left {
            width: 900px;
            .page19-body-header {
                height: 33px;
                font-size: 24px;

                font-weight: bold;
                color: #333333;
                line-height: 33px;
                margin-bottom: 10px;
            }
        }
        .page19-body-right {
            width: 853px;
            .page13-map {
              width: 100%;
              height: 760px;
              position: relative;
            }
            .page13-map-legend {
                flex-grow: 1;
                padding: 23px 24px;

                .page13-map-legend-item {
                    font-size: 20px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 28px;
                    margin-right: 36px;
                }
                .page13-map-legend-item:last-child {
                    margin-right: 0;
                }
                .page13-map-legend-point {
                    width: 22px;
                    height: 22px;
                    margin-right: 12px;
                    border-radius: 50%;

                  .point1 {
                    background-color: #1644ff;
                  }
                }
            }
            .page13-map-tips {
                flex-shrink: 0;
                text-align: right;
                height: 28px;
                font-size: 20px;
                font-weight: 400;
                color: #9a9a9a;
                line-height: 28px;
            }
        }
    }
}
</style>
